/**
 * 機能ごとの内訳の「機能」の列のセル。機能区分の行には、その下の機能の行を表示・非表示にするボタンを置き、
 * 機能の行は字下げして、どの機能区分の行の下にあるかを示す。
 * 見出しには、同じ形のボタンを1つ置き、すべての機能区分の行をまとめて開け閉めする。
 */

import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';

import type { RowContext } from './detailColumns';

/** ボタンの幅。ボタンのない行も同じ幅を空けて、名称の位置をそろえる */
const BUTTON = 'inline-flex h-5 w-5 shrink-0 items-center justify-center';
const CLICKABLE = `${BUTTON} rounded text-gray-600 hover:bg-gray-100`;

/**
 * 見出しのボタン。すべての機能区分の行が開いていれば、まとめて閉じる。そうでなければ、まとめて開く。
 * 行のボタンと同じく、閉じた向き（＞）は開く、開いた向き（∨）は閉じる操作を表す
 */
export function ExpandAllButton({
  expanded,
  onToggle,
}: {
  expanded: boolean;
  onToggle: () => void;
}) {
  const label = expanded ? 'すべての機能を閉じる' : 'すべての機能を表示する';
  return (
    <button type="button" className={CLICKABLE} aria-label={label} title={label} onClick={onToggle}>
      {expanded ? <ChevronDownIcon size={16} /> : <ChevronRightIcon size={16} />}
    </button>
  );
}

export function FeatureLabel({ label, context }: { label: string; context: RowContext }) {
  return (
    <span className={`inline-flex items-center gap-1 ${context.depth > 0 ? 'pl-6' : ''}`}>
      {context.expanded === null ? (
        <span className={BUTTON} />
      ) : (
        <button
          type="button"
          className={CLICKABLE}
          aria-expanded={context.expanded}
          aria-label={`${label}の機能を${context.expanded ? '閉じる' : '表示する'}`}
          onClick={(e) => {
            e.stopPropagation();
            context.toggle();
          }}
        >
          {context.expanded ? <ChevronDownIcon size={16} /> : <ChevronRightIcon size={16} />}
        </button>
      )}
      {label}
    </span>
  );
}
